import {
  Button,
  Card,
  Col,
  Descriptions,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import React, { useImperativeHandle, useState, useRef } from "react";
import { doiTuongOptions } from "assets/constants/select-catagory-options";
import { birthday2Age, convertAgeToWords } from "helper/common";
import "./SignSecure.scss";
import { receiveService } from "api";
import { HeaderPrintForm, Notification } from "components/common";
import SignatureCanvas from "react-signature-canvas";
import moment from "moment";
import NewSignSecure from "./NewSignSecure";
import SignPdfView from "pages/Receive/Receive/components/SignSecure/SignPdfView/SignPdfView";
import ContentSignSecure from "./ContentSignSecure";

const SignSecure = (props) => {
  const { modalRef } = props;
  const sigCanvas = useRef<any>();
  const bvCanvas = useRef<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [thongTinBN, setThongTinBN] = useState<any>(null);
  const printRef = useRef<any>();
  const NewPrintRef = useRef();
  const modalViewer = useRef<any>();
  useImperativeHandle(modalRef, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setThongTinBN: setThongTinBN,
  }));
  const openModal = () => {
    if (sigCanvas.current) {
      sigCanvas.current?.clear();
    }
    if (bvCanvas.current) {
      bvCanvas.current.clear();
    }
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setThongTinBN(null);
    setIsModalOpen(false);
  };
  const getThanNhan = (hoTen, quanHe) => {
    if (hoTen) {
      return quanHe ? hoTen + `(${quanHe})` : hoTen;
    }
    return "";
  };

  const onClearSign = () => {
    sigCanvas.current.clear();
    // hoTenCanvas.current.clear();
    bvCanvas.current.clear();
    // sigBvCanvas.current.clear();
  };

  const onSaveSign = async () => {
    if (sigCanvas.current.isEmpty()) {
      Notification("warning", "Vui lòng điền đầy đủ chữ kí");
      return;
    }

    // const signatureHotenDataURL = hoTenCanvas.current.toDataURL();

    const signatureDataURL = sigCanvas.current.toDataURL();
    // const bvDataURL = bvCanvas.current.toDataURL();
    // const signatureBvDataURL = sigBvCanvas.current.toDataURL();

    // setSignatureHotenImage(signatureHotenDataURL);
    // setSignatureImage(signatureDataURL);
    // setBvImage(bvDataURL);
    // setSignatureBvImage(signatureBvDataURL);

    try {
      const res = await receiveService.postSignSecure({
        idBenhNhan: thongTinBN?.maBenhNhan,
        chuKy: {
          hotenBN: "",
          chuKyBN: signatureDataURL,
          hoTenBV: null,
          chuKyBV: null,
        },
        phieuKhamDangKyBaoMatDto: {
          ...thongTinBN,
          tuoi: convertAgeToWords(birthday2Age(thongTinBN?.ngaySinh)),
        },
      });
      Notification("success", "Lưu chữ ký thành công");
      closeModal();
    } catch (error) {
      if (error.response.status == 400) {
        return Notification("warning", error.response.data);
      }
      Notification("error", "Lưu chữ ký không thành công");
    }
  };

  const getTodayString = () => {
    // const today = moment().format();
    const day = moment().format("DD");
    const month = moment().format("MM");
    const year = moment().format("YYYY");
    const time = moment().format("HH:mm");
    return `${time} Ngày ${day} tháng ${month} năm ${year}`;
  };

  return (
    <Row className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={960}
      >
        <div className="print-sign" style={{ display: "block" }}>
          <Space
            direction="vertical"
            size={"large"}
            style={{ maxWidth: "100%" }}
          >
            <div>
              <ContentSignSecure
                thongTinBN={thongTinBN}
                printRef={printRef}
                sigCanvas={sigCanvas}
              />
            </div>
            <Row>
              <Col span={12} style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="primary"
                  className="btn-sub"
                  onClick={onClearSign}
                >
                  Xoá chữ kí
                </Button>
              </Col>
              <Col
                span={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  type="primary"
                  onClick={onSaveSign}
                  size={"large"}
                  id="btn-ki-bao-mat"
                >
                  Lưu chữ kí
                </Button>
              </Col>
            </Row>
          </Space>
        </div>
      </Modal>
      <NewSignSecure ref={NewPrintRef} thongTinBN={thongTinBN}></NewSignSecure>
    </Row>
  );
};
export default SignSecure;
